import { TweenLite, Power2 } from 'gsap'

import EventHubMixin from '@/mixins/EventHub.js'
import APIMixin from '@/mixins/API.js'
import SizesMixin from '@/mixins/Sizes.js'

import AppVideo from '@/components/app-video'
import AppWordsFade from '@/components/app-words-fade'
import AppPicture from '@/components/app-picture'
import AppIconPlay from '@/components/app-icon-play'
import AppPageHomePushItem from '@/components/app-page-home-push-item'

import AutoPlay from '@/utils/AutoPlay.js'

export default
{
    name: 'app-page-home',

    mixins:
    [
        EventHubMixin,
        APIMixin,
        SizesMixin
    ],

    components:
    {
        AppVideo,
        AppWordsFade,
        AppPicture,
        AppIconPlay,
        AppPageHomePushItem
    },

    data()
    {
        return {
            content: null,
            step: - 1,
            autoplaySupported: true,
            animatedIntro: false,
            textVisible: false,
            fakeLoadingOver: false
        }
    },

    watch:
    {
        step(value)
        {
            switch(value)
            {
                case 0:
                    this.$eventHub.$emit('headerLogo.setState', { state: 'hidden' })
                    this.$eventHub.$emit('headerTrigger.setState', { state: 'hidden' })
                    this.$eventHub.$emit('line.moveTo', this.sizes.height * 0.5 + 100)

                    this.updateSubTitlePosition()

                    break

                case 1:
                    this.updateSubTitlePosition()

                    this.$eventHub.$emit('line.moveTo', this.sizes.height * 0.5 + 100)

                    TweenLite.to(this.strokes.blue, 2, { length: this.sizes.width, ease: Power2.easeOut, onComplete: () =>
                    {
                        this.fakeLoadingOver = true
                    } })
                    TweenLite.to(this.strokes.white, 3, { length: this.sizes.width, ease: Power2.easeOut, onComplete: () =>
                    {
                        if(this.autoplaySupported || this.videoPlaying || this.$root.config.platform.os === 'iOS')
                        {
                            this.step = 2
                        }
                    } })

                    break

                case 2:

                    TweenLite.to(this.strokes.blue, 1, { x: this.sizes.width * 0.5, length: 0, ease: Power2.easeInOut })
                    TweenLite.to(this.strokes.white, 1, { x: this.sizes.width * 0.5, length: 0, ease: Power2.easeInOut })

                    window.setTimeout(() =>
                    {
                        TweenLite.to(this.disc, 0.3, { radius: 3 })
                    }, typeof this.$root.$previousRoute === 'undefined' ? 900 : 100)

                    window.setTimeout(() =>
                    {
                        this.updateSubTitlePosition()
                    }, typeof this.$root.$previousRoute === 'undefined' ? 800 : 100)

                    window.setTimeout(() =>
                    {
                        this.$eventHub.$emit('headerLogo.setState', { state: 'logo' })
                        this.$eventHub.$emit('line.setElement', this.$refs.lineMark, true)
                    }, typeof this.$root.$previousRoute === 'undefined' ? 1000 : 100)

                    window.setTimeout(() =>
                    {
                        this.textVisible = true
                    }, typeof this.$root.$previousRoute === 'undefined' ? 1500 : 100)

                    break
            }
        }
    },

    created()
    {
        // this.animatedIntro = !this.$root.config.platform.touch
        this.animatedIntro = true
        this.videoPlaying = false

        AutoPlay.isSupported((result) =>
        {
            this.autoplaySupported = result
            // this.autoplaySupported = false
        })

        if(typeof this.$root.$previousRoute === 'undefined')
        {
            this.step = 0
        }
        // else
        // {
        //     this.step = 2
        // }

        this.fetch('pages', { slug: 'general,home', per_page: 1000 }, (data, error) =>
        {
            // Error
            if(error === true || data.length < 1)
            {
                this.$router.push({ name: '404' })
                return
            }

            // Direct access to home page
            if(this.step === 0)
            {
                this.step = 1
            }

            // From another page
            if(typeof this.$root.$previousRoute !== 'undefined')
            {
                this.step = 2
            }

            this.content = { acf: { ...data[1].acf, main_video_url: data[0].acf.main_video_url } }

            // SEO
            document.title = this.content.acf.seo_title ? this.content.acf.seo_title : this.content.acf.title.replace(/<br ?\/?>/gi, '')
            if(this.content.acf.seo_description)
            {
                document.querySelector('meta[name=description]').content = this.content.acf.seo_description
            }

            // Papillon
            this.$nextTick(() =>
            {
                window.dispatchEvent(new Event('papillon'))
            })

            this.$nextTick(() =>
            {
                // Subtitle
                this.$subTitle = this.$refs.subTitle
                this.$subTitleInner = this.$refs.subTitleInner

                this.updateSubTitlePosition()
                this.setCta1Hover()
                this.setCta2Hover()
            })
        }, this.$root.isFirstPage())
    },

    mounted()
    {
        // Strokes
        this.strokes = {}

        this.strokes.blue = {}
        this.strokes.blue.x = 0
        this.strokes.blue.length = 0
        this.strokes.blue.lineWidth = 1
        this.strokes.blue.strokeStyle = '#3092d0'

        this.$eventHub.$emit('line.createStroke', this.strokes.blue)

        this.strokes.white = {}
        this.strokes.white.x = 0
        this.strokes.white.length = 0
        this.strokes.white.lineWidth = 1
        this.strokes.white.strokeStyle = '#ffffff'

        this.$eventHub.$emit('line.createStroke', this.strokes.white)

        // Disc
        this.disc = {}
        this.disc = {}
        this.disc.x = this.sizes.width * 0.5
        this.disc.radius = 0
        this.disc.fillStyle = '#ffffff'

        this.$eventHub.$emit('line.createDisc', this.disc)
    },

    destroyed()
    {
        this.destroyed = true

        this.$eventHub.$emit('line.deleteStroke', this.strokes.blue)

        const $eventHub = this.$eventHub
        let disc = this.disc
        let strokeWhite = this.strokes.white

        TweenLite.to(this.strokes.white, 1, { x: this.sizes.width, length: 0, ease: Power2.easeInOut, onComplete()
        {
            $eventHub.$emit('line.deleteStroke', strokeWhite)
            strokeWhite = null
        } })

        TweenLite.to(this.disc, 1, { x: this.sizes.width + 3, radius: 0, ease: Power2.easeInOut, onComplete()
        {
            $eventHub.$emit('line.deleteDisc', disc)
            disc = null
        } })
    },

    methods:
    {
        onVideoPlay()
        {
            this.videoPlaying = true
            this.$refs.video.$el.classList.add('playing')
        },

        onResize()
        {
            this.strokes.blue.x = 0
            this.strokes.white.x = 0

            this.disc.x = this.sizes.width * 0.5

            if(this.cta1)
            {
                this.cta1.bounding = this.cta1.$inner.getBoundingClientRect()
            }
        },

        setCta1Hover()
        {
            this.cta1 = {}
            this.cta1.$element = this.$refs.cta1.$el
            this.cta1.$inner = this.$refs.cta1Inner
            this.cta1.bounding = this.cta1.$inner.getBoundingClientRect()

            this.cta1.$element.addEventListener('mouseenter', () =>
            {
                if(this.destroyed)
                {
                    return
                }

                TweenLite.killTweensOf(this.strokes.white)
                TweenLite.killTweensOf(this.disc)

                TweenLite.to(this.strokes.white, 0.5, { x: this.cta1.bounding.left, length: this.cta1.bounding.width, ease: Power2.easeOut })
                TweenLite.to(this.disc, 0.25, { radius: 0, ease: Power2.easeInOut })

                this.$eventHub.$emit('line.setElement', this.$refs.lineMarkHover, true)
            })

            this.cta1.$element.addEventListener('mouseleave', () =>
            {
                if(this.destroyed)
                {
                    return
                }

                TweenLite.killTweensOf(this.strokes.white)
                TweenLite.killTweensOf(this.disc)

                TweenLite.to(this.strokes.white, 0.5, { x: this.cta1.bounding.left + this.cta1.bounding.width * 0.5, length: 0, ease: Power2.easeOut })
                TweenLite.to(this.disc, 0.25, { radius: 3, ease: Power2.easeInOut, delay: 0.25 })

                this.$eventHub.$emit('line.setElement', this.$refs.lineMark, true)
            })
        },

        setCta2Hover()
        {
            this.cta2 = {}
            this.cta2.$element = this.$refs.cta2
            this.cta2.$inner = this.$refs.cta2Inner
            this.cta2.bounding = this.cta2.$inner.getBoundingClientRect()

            this.cta2.$element.addEventListener('mouseenter', () =>
            {
                if(this.destroyed)
                {
                    return
                }

                TweenLite.killTweensOf(this.strokes.white)
                TweenLite.killTweensOf(this.disc)

                TweenLite.to(this.strokes.white, 0.5, { x: this.cta2.bounding.left, length: this.cta2.bounding.width, ease: Power2.easeOut })
                TweenLite.to(this.disc, 0.25, { radius: 0, ease: Power2.easeInOut })

                this.$eventHub.$emit('line.setElement', this.$refs.lineMarkHover, true)
            })

            this.cta2.$element.addEventListener('mouseleave', () =>
            {
                if(this.destroyed)
                {
                    return
                }

                TweenLite.killTweensOf(this.strokes.white)
                TweenLite.killTweensOf(this.disc)

                TweenLite.to(this.strokes.white, 0.5, { x: this.cta2.bounding.left + this.cta2.bounding.width * 0.5, length: 0, ease: Power2.easeOut })
                TweenLite.to(this.disc, 0.25, { radius: 3, ease: Power2.easeInOut, delay: 0.25 })

                this.$eventHub.$emit('line.setElement', this.$refs.lineMark, true)
            })
        },

        updateSubTitlePosition()
        {
            // No subtitle yet
            if(!this.$subTitle)
            {
                return
            }

            // Update position on step
            switch(this.step)
            {
                case 0:
                case 1:
                    const boundings = this.$subTitle.getBoundingClientRect()
                    const targetTop = this.sizes.height * 0.5
                    const diff = targetTop - boundings.top - boundings.height * 0.5

                    this.$subTitleInner.style.transform = `translateY(${diff}px)`
                    break

                case 2:
                    this.$subTitleInner.classList.add('animated')
                    this.$subTitleInner.style.transform = 'translateY(0px)'
                    break
            }
        },

        onClick()
        {
            switch(this.step)
            {
                case 1:
                    if(!this.autoplaySupported)
                    {
                        this.$refs.video.$video.currentTime = 0
                        this.$refs.video.play()
                        this.step = 2
                    }
                    break

                case 2:
                    this.$router.push({ name: `${this.$route.meta.lang}_chapters` })
                    break
            }
        },

        onMainVideoClick()
        {
            window.open(this.content.acf.main_video_url, '_blank')
        },

        onVideoClick(video)
        {
            // Open URL
            if(video.url)
            {
                window.open(video.url, '_blank')
            }

            // Open player
            else
            {
                this.$eventHub.$emit('player.activate', video.ID)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-home/script.js